import axios from 'axios';

const PLACES_API_URL = process.env.REACT_APP_GOOGLE_PLACES_API_URL;

// Check if API URL is properly configured
const isAPIConfigured = () => {
  const isConfigured = PLACES_API_URL && !PLACES_API_URL.includes('your-api-gateway-url');
  return isConfigured;
};

// Generate a session token for billing optimization
export function generateSessionToken() {
  return 'session_' + Math.random().toString(36).substring(2, 9) + Date.now();
}

export const searchAddresses = async (input, sessionToken = null) => {
  try {
    if (!input || input.length < 3) {
      return { predictions: [] };
    }
    
    if (!isAPIConfigured()) {
      console.warn('Google Places API URL not configured.');
      return { predictions: [] };
    }
    
    const response = await axios.post(PLACES_API_URL, {
      input: input,
      operation: 'autocomplete',
      sessionToken: sessionToken || generateSessionToken()
    }, {
      timeout: 10000
    });
    
    return response.data;
  } catch (error) {
    console.error('Error searching addresses:', error);
    throw new Error(`Failed to search addresses: ${error.message}`);
  }
};

export const getPlaceDetails = async (placeId, sessionToken = null) => {
  try {
    if (!isAPIConfigured()) {
      throw new Error('Google Places API URL not configured');
    }
    
    const response = await axios.post(PLACES_API_URL, {
      input: placeId,
      operation: 'details',
      sessionToken: sessionToken
    }, {
      timeout: 10000
    });
    
    return response.data;
  } catch (error) {
    console.error('Error getting place details:', error);
    throw new Error('Failed to get place details');
  }
};

export const geocodeAddress = async (address) => {
  try {
    if (!isAPIConfigured()) {
      throw new Error('Google Places API URL not configured');
    }
    
    const response = await axios.post(PLACES_API_URL, {
      input: address,
      operation: 'geocode'
    }, {
      timeout: 10000
    });
    
    return response.data;
  } catch (error) {
    console.error('Error geocoding address:', error);
    throw new Error('Failed to geocode address');
  }
};

export default {
  searchAddresses,
  getPlaceDetails,
  geocodeAddress,
  generateSessionToken
}; 